export const list = () =>
  fetch(
    window.ajax_object.root +
      'wp/v2/iv-players/?status=publish&_wpnonce=' +
      window.ajax_object.nonce,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    },
  ).then(data => {
    return data.json()
  })

export const create = (title, url, timings) =>
  fetch(
    window.ajax_object.root +
      'wp/v2/iv-players/?&_wpnonce=' +
      window.ajax_object.nonce,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
      body: JSON.stringify({
        title: title,
        status: 'publish',
        'video-fields': btoa(
          JSON.stringify({
            url: url,
            timings: timings,
          }),
        ),
      }),
    },
  ).then(data => {
    return data.json()
  })

export const retrieve = id =>
  fetch(
    window.ajax_object.root +
      'wp/v2/iv-players/' +
      id +
      '/?status=publish&_wpnonce=' +
      window.ajax_object.nonce,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    },
  ).then(data => {
    return data.json()
  })

export const update = (id, title, url, timings) =>
  fetch(
    window.ajax_object.root +
      'wp/v2/iv-players/' +
      id +
      '/?&_wpnonce=' +
      window.ajax_object.nonce,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
      body: JSON.stringify({
        title: title,
        status: 'publish',
        'video-fields': btoa(
          JSON.stringify({
            url: url,
            timings: timings,
          }),
        ),
      }),
    },
  ).then(data => {
    return data.json()
  })

export const remove = id =>
  fetch(
    window.ajax_object.root +
      'wp/v2/iv-players/' +
      id +
      '/?status=publish&_wpnonce=' +
      window.ajax_object.nonce,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    },
  ).then(data => {
    return data.json()
  })

export const mediaList = mediaType => {
  let url = 'wp/v2/media/?_wpnonce=' + window.ajax_object.nonce
  if (mediaType) {
    url =
      'wp/v2/media/?media_type=' +
      mediaType +
      '&_wpnonce=' +
      window.ajax_object.nonce
  }
  return fetch(window.ajax_object.root + url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json',
    },
  }).then(data => {
    return data.json()
  })
}
